import type { GameMetadata, HubStarsProduct } from '../types/hub.ts';

export const GAME_CATALOG: GameMetadata[] = [
  {
    id: 'galaxy-empire',
    name: 'Đế Chế Thiên Hà',
    nameEn: 'Galaxy Empire',
    category: 'strategy',
    categoryName: 'Chiến Thuật Không Gian',
    icon: '🚀',
    badge: 'FULL PLAYABLE',
    description: 'Xây dựng căn cứ không gian, khai thác tài nguyên (Kim loại, Heli-3, Tín dụng), nghiên cứu công nghệ, đóng hạm đội, khám phá thiên hà và liên minh tác chiến PvP thời gian thực.',
    status: 'released',
    statusText: 'Đã Phát Hành',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Backend D1 Remote trực tiếp, mô phỏng hạm đội PvP/PvE, di chuyển thực tế trên bản đồ sao.',
    playRoute: '/games/galaxy',
    playsCount: 8930,
    rating: 4.9,
    tags: ['Chiến Thuật 4X', 'PvP', 'Đóng Tàu', 'Liên Minh', 'Full Game'],
    isFeatured: true,
  },
  {
    id: 'one-life',
    name: 'Một Kiếp Người',
    nameEn: 'One Life — Many Destinies',
    category: 'simulation',
    categoryName: 'Mô Phỏng Nhân Sinh',
    icon: '👶',
    badge: 'MVP HOÀN CHỈNH',
    description: 'Rút ngẫu nhiên một kiếp người theo dữ liệu thật UN WPP 2024 & World Bank. Trải nghiệm trọn vẹn 8 giai đoạn đời người từ lúc chào đời tới tuổi già thanh thản, có lưu và chia sẻ kết quả.',
    status: 'released',
    statusText: 'Đã Phát Hành',
    maturityTier: 'MVP',
    aiDetails: 'Mô hình phân bổ 2 chế độ: Ca sinh hằng năm (Chuẩn UN WPP 2024) vs Quy mô dân số thế giới.',
    playRoute: '/games/one-life',
    playsCount: 1420,
    rating: 4.9,
    tags: ['Mô Phỏng', 'Triết Lý', 'Dữ Liệu Thật', 'Nhiều Kết Cục', 'MVP'],
    isFeatured: true,
  },
  {
    id: 'bible-quiz',
    name: 'Đố Vui Thánh Kinh',
    nameEn: 'Scripture Quest & Knowledge',
    category: 'quiz_puzzle',
    categoryName: 'Học Hỏi & Đố Vui',
    icon: '📖',
    badge: 'FULL PLAYABLE',
    description: 'Ngân hàng kiến thức Kinh Thánh & Thần học Công giáo đa dạng (Cựu Ước, Tân Ước, Bảy Bí Tích, Phụng Vụ, Các Thánh). Ba chế độ chơi: Học Hỏi & Khám Phá, Thử Thách 10 Câu tính giờ combo, và Leo Tháp Thánh Kinh 3 mạng.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Hệ thống câu hỏi Kinh Thánh & Các Bí Tích phân tầng, 3 chế độ Học Hỏi / Thử Thách / Leo Tháp.',
    playRoute: '/games/bible-quiz',
    playsCount: 2310,
    rating: 4.9,
    tags: ['Kinh Thánh', 'Giáo Lý', 'Các Bí Tích', 'Leo Tháp', 'Full Engine'],
    isFeatured: true,
  },
  {
    id: 'xiangqi',
    name: 'Cờ Tướng Kỳ Đạo',
    nameEn: 'Vietnamese Xiangqi Masters',
    category: 'board_game',
    categoryName: 'Trí Tuệ Cổ Điển',
    icon: '♟️',
    badge: 'FULL PLAYABLE',
    description: 'Bàn cờ tướng truyền thống đầy đủ chuẩn luật thi đấu 32 quân: Tướng, Sĩ, Tượng, Xe, Pháo, Mã, Tốt. Kiểm tra cản chân mã, cản mắt tượng, lộ mặt tướng, pháo ăn qua ngòi, chiếu và chiếu bí. Tích hợp AI Minimax Alpha-Beta và chế độ 2 người chơi.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Engine chuẩn luật 32 quân, cản mã, cản tượng, lộ mặt tướng, pháo ngòi, AI Minimax Alpha-Beta.',
    playRoute: '/games/xiangqi',
    playsCount: 5120,
    rating: 4.9,
    tags: ['Cờ Tướng', 'Trí Tuệ', 'Đấu Với Máy', '2 Người', 'Full Engine'],
    isFeatured: true,
  },
  {
    id: 'chess',
    name: 'Cờ Vua Trí Tuệ',
    nameEn: 'Classic International Chess',
    category: 'board_game',
    categoryName: 'Trí Tuệ Quốc Tế',
    icon: '♚',
    badge: 'FULL PLAYABLE',
    description: 'Bàn cờ vua chuẩn quốc tế FIDE đầy đủ 32 quân, luật đi quân chính thống: Tốt đi 1-2 ô, bắt Tốt qua đường (en passant), phong cấp Hậu/Xe/Tượng/Mã, Nhập thành gần/xa, kiểm tra Chiếu, Chiếu bí, Hòa cờ (Pat). AI Minimax Alpha-Beta và chế độ 2 người cùng máy.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Engine chuẩn luật 32 quân FIDE, bắt tốt qua đường, nhập thành, phong cấp, AI Minimax Alpha-Beta 2 cấp độ.',
    playRoute: '/games/chess',
    playsCount: 4620,
    rating: 4.9,
    tags: ['Cờ Vua', 'Trí Tuệ FIDE', 'AI Minimax', '2 Người', 'Full Engine'],
    isFeatured: true,
  },
  {
    id: 'su-quan',
    name: 'Loạn 12 Sứ Quân',
    nameEn: '12 Warlords Tactics',
    category: 'strategy',
    categoryName: 'Chiến Thuật Lịch Sử',
    icon: '⚔️',
    badge: 'FULL PLAYABLE',
    description: 'Chiến dịch lịch sử thống nhất 12 Sứ Quân thời Tiền Lê (944-968). Quản lý lãnh thổ Hoa Lư, khẩn hoang lương thảo, chiêu mộ dũng sĩ, dụng kế công thành (đột kích, phục kích ven sông, vây thành) thu phục 12 châu quận định đô xưng đế.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Bản đồ 12 sứ quân, quản lý tài nguyên, chiến lược công thành đa dạng, lưu tiến độ thống nhất.',
    playRoute: '/games/su-quan',
    playsCount: 2150,
    rating: 4.9,
    tags: ['12 Sứ Quân', 'Chiến Thuật Lịch Sử', 'Thống Nhất', 'Đại Cồ Việt', 'Full Engine'],
    isFeatured: true,
  },
  {
    id: 'ninja-legacy',
    name: 'Huyền Thoại Ninja',
    nameEn: 'Ninja Legacy 2D',
    category: 'rpg_action',
    categoryName: 'Nhập Vai 2D',
    icon: '🥷',
    badge: 'FULL PLAYABLE',
    description: 'Game nhập vai hành động Ninja 2D phong cách Ninja School. Di chuyển, nhảy platform, chém kiếm, phóng phi tiêu, dùng kỹ năng Hỏa Độn, quái vật tuần tra AI, nhặt vàng rơi rớt, 3 màn chơi (Rừng Trúc, Thung Lũng Cổ, Hang Quỷ) và nâng cấp trang bị tại Làng.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Canvas 60FPS platformer engine, camera tracking, quái tuần tra aggro AI, hệ thống rơi trang bị & nâng cấp Làng.',
    playRoute: '/games/ninja',
    playsCount: 3410,
    rating: 4.9,
    tags: ['Ninja', 'Action RPG', '2D Canvas', 'Boss Fights', 'Full Engine'],
    isFeatured: true,
  },
  {
    id: 'tam-quoc',
    name: 'Chiến Thần Tam Quốc',
    nameEn: 'Warlords 9-Grid Tactics',
    category: 'strategy',
    categoryName: 'Chiến Thuật Cổ Trang',
    icon: '🏯',
    badge: 'FULL PLAYABLE',
    description: 'Trận pháp 9 ô (3x3) turn-based chuẩn chiến thuật Tam Quốc. Bày trận danh tướng (Quan Vũ, Triệu Vân, Trương Phi, Hoàng Trung, Gia Cát Lượng...), tính toán thứ tự tốc độ ra chiêu, tích lũy nộ khí thi triển tuyệt kỹ, khắc chế binh chủng kỵ-cung-bộ và vượt các ải chiến dịch khốc liệt.',
    status: 'released',
    statusText: 'Đã Hoàn Thiện',
    maturityTier: 'FULL PLAYABLE',
    aiDetails: 'Engine mô phỏng lượt đấu 9-grid theo tốc độ và nộ khí, khắc chế thuộc tính, chiến dịch nhiều ải.',
    playRoute: '/games/tam-quoc',
    playsCount: 3880,
    rating: 4.9,
    tags: ['Tam Quốc', 'Trận Pháp 9 Ô', 'Turn-Based RPG', 'Tuyệt Kỹ Nộ', 'Full Engine'],
    isFeatured: true,
  },
];

export const HUB_STARS_PRODUCTS: HubStarsProduct[] = [
  {
    id: 'vip_pass_30d',
    titleVi: 'Thẻ VIP GameHub (30 Ngày)',
    titleEn: 'GameHub VIP Pass (30 Days)',
    descriptionVi: 'Nhận huy hiệu VIP rực rỡ, mở khóa toàn bộ avatar độc quyền trên tất cả các game hoài cổ và tăng 20% EXP.',
    starsPrice: 150,
    category: 'vip',
    durationDays: 30,
    icon: '👑',
  },
  {
    id: 'onelife_golden_destiny',
    titleVi: 'Gói Số Mệnh Hoàng Kim (Một Kiếp Người)',
    titleEn: 'Golden Destiny Pack (One Life)',
    descriptionVi: 'Mở khóa đặc quyền tự chọn quốc gia sinh ra, gia đình quý tộc và 10 lượt quay số mệnh thượng lưu.',
    starsPrice: 75,
    category: 'cosmetic',
    icon: '🌟',
  },
  {
    id: 'retro_avatar_bundle',
    titleVi: 'Bộ Khung Avatar Hoài Cổ',
    titleEn: 'Retro Avatar Frame Bundle',
    descriptionVi: '5 khung viền avatar phong cách GameBoy, Pixel Retro và Trống Đồng Đông Sơn độc nhất vô nhị.',
    starsPrice: 50,
    category: 'cosmetic',
    icon: '🖼️',
  },
  {
    id: 'prod_pdf_album',
    titleVi: 'Ebook Kỷ Niệm Game Xưa (PDF)',
    titleEn: 'Retro Gaming Memory Book (PDF)',
    descriptionVi: 'Cuốn sách nghệ thuật pixel và hồi ức 20 năm game tuổi thơ định dạng PDF.',
    starsPrice: 19,
    category: 'cosmetic',
    icon: '📚',
  },
  {
    id: 'dev_coffee_support',
    titleVi: 'Mời Cà Phê Đội Ngũ Phát Triển',
    titleEn: 'Buy Developers a Coffee',
    descriptionVi: 'Ủng hộ dự án Game Ngày Xưa tiếp tục duy trì server miễn phí và phát triển thêm các tựa game tuổi thơ.',
    starsPrice: 25,
    category: 'cosmetic',
    icon: '☕',
  },
];
